import React, { useState } from 'react';
import './CredentialSuccessModal.css';

export default function CredentialSuccessModal({ credential, onClose, onContinue, title = 'User added successfully!' }) {
  const [showPassword, setShowPassword] = useState(true);
  const [copied, setCopied] = useState(false);
  if (!credential) return null;

  const copy = async () => {
    const text = `Name: ${credential.name || 'User'}\nUsername: ${credential.username}\nTemporary password: ${credential.password}`;
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
    } catch {
      setCopied(false);
    }
  };

  const finish = () => {
    if (onContinue) onContinue();
    else onClose?.();
  };

  return <div className="credential-success-overlay" role="presentation">
    <section className="credential-success-modal" role="dialog" aria-modal="true" aria-labelledby="credential-success-title">
      <div className="credential-success-icon" aria-hidden="true">✓</div>
      <span className="credential-success-kicker">Portal access created</span>
      <h2 id="credential-success-title">{title}</h2>
      <p>Copy these login details now and give them privately to <strong>{credential.name || 'the user'}</strong>.</p>
      <div className="credential-success-details">
        <label><span>Username</span><code>{credential.username}</code></label>
        <label><span>Temporary password</span><div><code>{showPassword ? credential.password : '••••••••••••'}</code><button type="button" onClick={() => setShowPassword(value => !value)}>{showPassword ? 'Hide' : 'Show'}</button></div></label>
      </div>
      <div className="credential-success-note"><span>!</span><p>The user will be asked to change this temporary password after signing in.</p></div>
      <div className="credential-success-actions">
        <button type="button" className="btn btn-outline" onClick={copy}>{copied ? '✓ Copied' : 'Copy credentials'}</button>
        <button type="button" className="btn btn-primary" onClick={finish}>Done</button>
      </div>
      {onClose && <button type="button" className="credential-success-close" onClick={onClose} aria-label="Close credential popup">×</button>}
    </section>
  </div>;
}
